<template>
  <div>
	<lego-segment-wrapper small v-model="model.value">
		<lego-segment-button value="1" @click="onClick(1)" :disabled="disabled">{{$t('button.use')}}</lego-segment-button>
		<lego-segment-button value="2" @click="onClick(0)" :disabled="disabled">{{$t('button.unused')}}</lego-segment-button>
	</lego-segment-wrapper>
  </div>
</template>

<script>
export default {
	name: 'ScpmTableSegment',
	inject: ['logAction'],
	props:['value', 'itemKey','tableIdx', 'disabled'],
	methods:{
		onClick(value){
			this.$emit('click',{tableIdx:this.tableIdx,logAction:value,value:'logAction'})
		}
	},
	data() {
        return {
			model : {
				value : String(this.value)
			}
		}
   },
   created(){
   }

}
</script>